import { useLocaleContext } from '../../context/LocaleContext.js'

export function FutureChatLoadingFallback() {
  const { t } = useLocaleContext()

  return (
    <div
      className="future-chat-loading-fallback"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="future-chat-loading-fallback-inner">
        <div className="future-chat-loading-mark" aria-hidden="true">
          F.B
        </div>
        <p className="future-chat-loading-label">{t('indicators.loadingSession')}</p>
        <div className="future-chat-loading-bars" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  )
}
